
const routes = [
    {
        path: "/certificate/applications/bulk-ebys",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "certificateapplication_bulksendebys"
        }
    }
];

export default routes;
